// useCotizacionesListXL - Sprint 44 Fase 3 Vista 4.
// Hook de lista de cotizaciones con filtros (q, estado), paginacion real,
// msg auto-dismiss 4s. Reusa cotizacionesService legacy.
import { useCallback, useEffect, useRef, useState } from 'react';
import * as svc from '../../cotizaciones/services/cotizacionesService';

const DEFAULT_PER_PAGE = 25;
const MSG_AUTO_DISMISS_MS = 4000;

export default function useCotizacionesListXL() {
  const [items, setItems]     = useState([]);
  const [total, setTotal]     = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setErr]         = useState(null);

  const [page, setPage]       = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [q, setQ]             = useState('');
  const [estado, setEstado]   = useState('');
  const [msg, setMsg]         = useState(null);

  const msgTimer = useRef(null);
  const pushMsg = useCallback((kind, text) => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
    setMsg({ kind, text });
    msgTimer.current = setTimeout(() => setMsg(null), MSG_AUTO_DISMISS_MS);
  }, []);
  useEffect(() => () => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const r = await svc.listCotizaciones({ page, per_page: perPage, q, estado });
      setItems(r.items || []);
      setTotal(r.total || 0);
    } catch (e) {
      setErr((e && e.message) || 'Error al listar cotizaciones');
      setItems([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, perPage, q, estado]);

  useEffect(() => { load(); }, [load]);

  const resetAndSetQ      = useCallback((v) => { setPage(1); setQ(v); }, []);
  const resetAndSetEstado = useCallback((v) => { setPage(1); setEstado(v); }, []);

  const totalPages = Math.max(1, Math.ceil((total || 0) / (perPage || 1)));
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return {
    items, total, loading, err,
    page, perPage, setPage, setPerPage,
    totalPages, canPrev, canNext,
    q, setQ: resetAndSetQ,
    estado, setEstado: resetAndSetEstado,
    msg, pushMsg, clearMsg: () => setMsg(null),
    load,
  };
}
